export default "__VITE_ASSET__mLc0mbT9__"